import { logger } from './logger/loggerInstance';

const isNoise = (message: string | Event, source?: string): boolean => {
  const msg = typeof message === 'string' ? message : '';

  return (
    msg.includes('chrome-extension') ||
    msg.includes('moz-extension') ||
    (source != null && source.includes('extension')) ||
    msg.includes('ResizeObserver loop limit exceeded') ||
    msg.includes('Script error.') ||
    msg.includes('Blocked script') ||
    msg.includes('Blocked by client')
  );
};

export const initGlobalErrorHandlers = (): void => {
  window.onerror = (
    message: string | Event,
    source?: string,
    lineno?: number,
    colno?: number,
    error?: unknown,
  ): void => {
    if (isNoise(message, source)) {
      return;
    }

    const safeMessage =
      typeof message === 'string' ? message : 'Unknown window error';
    const safeStack =
      error instanceof Error
        ? error.stack
        : typeof error === 'object' &&
            error !== null &&
            'stack' in error &&
            typeof (error as { stack?: unknown }).stack === 'string'
          ? (error as { stack: string }).stack
          : null;

    void logger.error('Global JS error', {
      source: 'window.onerror',
      context: {
        message: safeMessage,
        source,
        lineno,
        colno,
        stack: safeStack,
      },
    });
  };

  window.onunhandledrejection = (event: PromiseRejectionEvent): void => {
    const reason: unknown = event.reason;

    const safeMessage =
      typeof reason === 'object' &&
      reason !== null &&
      'message' in reason &&
      typeof (reason as { message: unknown }).message === 'string'
        ? (reason as { message: string }).message
        : typeof reason === 'string'
          ? reason
          : 'Unhandled rejection';

    const safeStack =
      typeof reason === 'object' &&
      reason !== null &&
      'stack' in reason &&
      typeof (reason as { stack?: unknown }).stack === 'string'
        ? (reason as { stack: string }).stack
        : null;

    if (isNoise(safeMessage)) {
      return;
    }

    void logger.error('Unhandled promise rejection', {
      source: 'window.onunhandledrejection',
      context: {
        reason: safeMessage,
        stack: safeStack,
      },
    });
  };

  const originalConsoleError = console.error;
  console.error = (...args: unknown[]): void => {
    const [firstArg] = args;

    let safeMessage = 'Unknown console.error';
    if (typeof firstArg === 'string') {
      safeMessage = firstArg;
    } else if (firstArg instanceof Error) {
      safeMessage = firstArg.message;
    }

    if (!isNoise(safeMessage)) {
      void logger.error('console.error', {
        source: 'console',
        context: {
          message: safeMessage,
          args,
        },
      });
    }

    originalConsoleError(...args);
  };
};
